import React from 'react';

export const Rocket = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
    <path
      d="M13.4167 18.0837L9.41667 14.0837M13.4167 18.0837C15.2791 17.3753 17.0658 16.482 18.75 15.417M13.4167 18.0837V24.7503C13.4167 24.7503 17.4567 24.017 18.75 22.0837C20.19 19.9237 18.75 15.417 18.75 15.417M9.41667 14.0837C10.1262 12.2429 11.0196 10.4784 12.0833 8.817C13.6369 6.33298 15.8002 4.28773 18.3673 2.87579C20.9345 1.46384 23.8202 0.732159 26.75 0.75033C26.75 4.377 25.71 10.7503 18.75 15.417M9.41667 14.0837L2.75 14.0837C2.75 14.0837 3.48333 10.0437 5.41667 8.75035C7.57667 7.31035 12.0833 8.75035 12.0833 8.75035M3.41667 20.0838C1.41667 21.7638 0.75 26.7504 0.75 26.7504C0.75 26.7504 5.73667 26.0838 7.41667 24.0838C8.36333 22.9638 8.35 21.2438 7.29667 20.2038C6.77841 19.7091 6.09572 19.4233 5.37963 19.4011C4.66355 19.379 3.9645 19.6221 3.41667 20.0838Z"
      stroke="#090925"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.4167 18.0837L9.41667 14.0837M13.4167 18.0837C15.2791 17.3753 17.0658 16.482 18.75 15.417M13.4167 18.0837V24.7503C13.4167 24.7503 17.4567 24.017 18.75 22.0837C20.19 19.9237 18.75 15.417 18.75 15.417M9.41667 14.0837C10.1262 12.2429 11.0196 10.4784 12.0833 8.817C13.6369 6.33298 15.8002 4.28773 18.3673 2.87579C20.9345 1.46384 23.8202 0.732159 26.75 0.75033C26.75 4.377 25.71 10.7503 18.75 15.417M9.41667 14.0837L2.75 14.0837C2.75 14.0837 3.48333 10.0437 5.41667 8.75035C7.57667 7.31035 12.0833 8.75035 12.0833 8.75035M3.41667 20.0838C1.41667 21.7638 0.75 26.7504 0.75 26.7504C0.75 26.7504 5.73667 26.0838 7.41667 24.0838C8.36333 22.9638 8.35 21.2438 7.29667 20.2038C6.77841 19.7091 6.09572 19.4233 5.37963 19.4011C4.66355 19.379 3.9645 19.6221 3.41667 20.0838Z"
      stroke="url(#paint0_linear_57448_5305)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_57448_5305"
        x1="-0.195454"
        y1="26.7504"
        x2="36.1075"
        y2="29.3197"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4900FF" />
        <stop offset="0.462476" stopColor="#D500FF" />
        <stop offset="1" stopColor="#FF9257" />
      </linearGradient>
    </defs>
  </svg>
);
